import { http } from "../config/http"

export const getChatTitleHistory = async (body: any) => {
    try {
        const response = await http.get(`get_list_of_conversations_ids_of_conversational_chat?session_id=${body.session_id}&user_id=${body.user_id}`);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const createChatSession = async (body: any) => {
    try {
        const response = await http.post('create_conversation', body);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const updateChatSessionTitle = async (body: any) => {
    try {
        const response = await http.put(`update_conversation_chat_history_title?session_id=${body.session_id}&user_id=${body.user_id}&conversation_id=${body.conversation_id}&new_title=${body.new_title}`, body);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const deleteChatSession = async (body: any) => {
    try {
        const response = await http.put(`delete_conversation_chat?conversation_id=${body.conversation_id}&user_id=${body.user_id}&session_id=${body.session_id}`);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const getMainChatHistory = async (body: any) => {
    try {
        const response = await http.get(`get_conversation_history_by_conversation_id?session_id=${body.session_id}&user_id=${body.user_id}&conversation_id=${body.conversation_id}&page_no=${body.page_no}&page.size=${body.page_size}`);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const getChartElementHistory = async (body: any) => {
    try {
        const response = await http.get(`get_chart_conversation_history_by_chart_conversation_id?session_id=${body.session_id}&user_id=${body.user_id}&chart_conversation_id=${body.chart_conversation_id}&page_no=${body.page_no}&page_size=${body.page_size}`);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const createConversation = async (body: any) => {
    try {
        const response = await http.post('conversational_chat', body);
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};

export const createChartConversation = async (body: any) => {
    try {
        const response = await http.post('conversational_chat',{
            user_id: body.user_id,
            session_id: body.session_id,
            question: body.question,
            context_scope: {
                chart_type: body.chart_type,
                chart_title: body.chart_title,
                x_axis: body.x_axis,
                y_axis: body.y_axis,
                location: body.location,
                metric: body.metric,
                metric_value: body.metric_value
            },
            conversation_id: body.conversation_id,
            chart_conversation_id: body.chart_conversation_id,
            group: body.group,
            title: body.title,
            is_chart_chat: true

        });
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
};